import Modal from 'react-modal';
import { ProfileThumb } from '../CardComponents';
import cx from "../../../styles";

const ConformationPopup = (props) => {
    const { isOpen, image, headingText, descriptionText, conformationBtnText, cancelBtnText, onCancel, onConformation } = props;
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => {if(onCancel) onCancel(false)}}
            overlayClassName={"conformation-modal"}
            shouldCloseOnOverlayClick={false}
        >
            <div className={cx('conformation-wrap')}>
                {
                    image &&
                    <ProfileThumb img={props.groupImage ? props.groupImage : ""} size="large" altName={`${props.groupName} icon`} />
                }

                {
                    headingText &&
                    <p className={cx('heading')}>{headingText}</p>
                }

                {
                    descriptionText &&
                    <p className={cx('description')}>{descriptionText}</p>
                }
                <div className={cx('button-wrap')}>
                    <button className={cx('cancel-btn')} onClick={() => { if (onCancel) onCancel(false) }}>{cancelBtnText}</button>
                    <button className={cx('submit-btn')} onClick={() => { if (onConformation) onConformation() }}>{conformationBtnText}</button>
                </div>
            </div>
        </Modal>
    );
}

export default ConformationPopup;